export enum PortOptionType {
    NO_SCHEDULE = 'NO_SCHEDULE',
    SCHEDULE = 'SCHEDULE',
}
